import { isEqual } from "lodash-es";

import { isSameListRef } from "../ListRef";

import { LevelPinnedLists } from "./getLevelPinnedLists";

export type PinnedListsChange = LevelPinnedLists;

// Compares a level's baseline with its save payload. A list or flag that either side does not
// mention is unchanged: the payload may not carry it, and a baseline without it was never read.
const getChangedPinnedLists = (
  baseline: LevelPinnedLists,
  updated: LevelPinnedLists
): PinnedListsChange | undefined => {
  const lists = updated.lists.filter(({ fields, ref }) => {
    const baselineList = baseline.lists.find((candidate) => isSameListRef(candidate.ref, ref));
    return !!baselineList && !isEqual(baselineList.fields, fields);
  });

  const isFlagChanged = (flag: "actions" | "engagement") =>
    baseline[flag] !== undefined && updated[flag] !== undefined && baseline[flag] !== updated[flag];
  const isActionsChanged = isFlagChanged("actions");
  const isEngagementChanged = isFlagChanged("engagement");

  return lists.length || isActionsChanged || isEngagementChanged
    ? {
        ...(isActionsChanged && { actions: updated.actions }),
        ...(isEngagementChanged && { engagement: updated.engagement }),
        lists,
      }
    : undefined;
};

export default getChangedPinnedLists;
